import Account from "../../../components/dashboard/account/Account"
import Navbar from "../../../components/dashboard/navbar/Navbar"
import Sidebar from "../../../components/dashboard/sidebar/Sidebar"
import styles from "../layout.module.css"

import { FaArrowRightToBracket } from "react-icons/fa6";
import { IconName } from "react-icons/gi";

import { selectSideNavOpen } from "../../../redux/slices/sharedSlice"
import { toggleSideNav } from "../../../redux/slices/sharedSlice"
import { useSelector } from "react-redux";
import { useState } from "react";

const AccountPage = () => {

    const open = useSelector(selectSideNavOpen)

    return (
        <section className={styles.pageContainer}>

            <div className={`${open ? styles.leftBarOpen : styles.leftBarClosed}`}><Sidebar /> </div>

            <div className={`${open ? styles.rightBarOpen : styles.rightBarClosed}`}>
                <Navbar page="Account" />
                <div className={styles.mainBar}>
                    <Account />
                </div>
            </div>

        </section>
    )
}

export default AccountPage;